<h2 mat-dialog-title>New Organization</h2>
<mat-dialog-content [style.width]="'350px'">
    <form class="cm-new-item-form">
        <mat-form-field appearance="fill">
            <input matInput placeholder="Name" [(ngModel)]="$name" name="name" />
        </mat-form-field>
        <mat-form-field appearance="fill">
            <input matInput placeholder="URL" [(ngModel)]="$url" name="url" />
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button mat-button color="accent" (click)="confirmCreate()" [disabled]="!$canConfirmCreate()">Create</button>
</mat-dialog-actions>
